import "./Studio.module.css";
import HeaderNavigazione from "@/reusable_sections/Header";
import BenvenutiInStudioMessSrl from "./sections/BenvenutiInStudioMessSrl";
import IlNostroTeamDiEsperti from "./sections/IlNostroTeamDiEsperti";
import Footer from "@/reusable_sections/Footer";
export default function StudioPage() {
  return <div>
      <HeaderNavigazione />
      <BenvenutiInStudioMessSrl />
      <IlNostroTeamDiEsperti />
      <Footer />
    </div>;
}